import { useMemo } from 'react'

import { UAParser } from 'ua-parser-js'

export const useUserAgentInfo = () => {
  const uaResults = useMemo(() => new UAParser().getResult(), [])
  return { uaResults }
}
